import { render, staticRenderFns } from "./GiftPointsCardSkeleton.vue?vue&type=template&id=42563278&scoped=true"
import script from "./GiftPointsCardSkeleton.vue?vue&type=script&lang=js"
export * from "./GiftPointsCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./GiftPointsCardSkeleton.vue?vue&type=style&index=0&id=42563278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42563278",
  null
  
)

export default component.exports